export default __webpack_public_path__ + "static/media/teaktree-logo.71329cb0.png";